import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';

import lang from '../../../../assets/i18n/en.json';
import './user.component.scss';
// import Button from 'react-bootstrap/Button';
import { DataTable } from 'primereact/datatable';
import React, { useState, useEffect, useCallback } from 'react';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import allImages from '../../../../assets/images/allImages';
import { Dropdown } from 'primereact/dropdown';
// import { InviteUser } from './InviteUser';
import { EditUserDetails } from './EditUserDetails';
import { ConfirmationPopup } from '../../../Common/confirmationPopup/ConfirmationPopup';
import { useSelector } from 'react-redux';
import { useApolloClient, useMutation } from '@apollo/client';
import {
  GetEnterpriseClientById,
} from '../../../../Queries/Queries';
import { UpdateEnterpriseClientRoleById } from '../../../../Mutations/Mutations';
import { isLogout } from '../../../../Redux/authSlice';
import { setLoaderFalse, setLoaderTrue } from '../../../../Redux/loaderSlice';
import { globalError } from '../../../../utils/global-error-handler';
import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router';
import { SendInvitation } from '../../BondAdmin/enterpriseList/SendInvitation';
import { GetEnterpriseClientByIdV2, GetEnterpriseUsers } from '../../../../Queries/QueriesUpdated';
import { UpdateClientUser } from '../../../../Mutations/MutationsUpdated';

export const UserManagement = () => {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const client = useApolloClient();
  const ERROR = lang.ERROR;
  const authReducer = useSelector((state) => state.authReducer);

  const [user, setUser] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showConfirm, setConfirm] = useState(false);
  const [singleEnterpriseClientStatus, setSignleEnterpriseClientStatus] =
    useState();
  const [onChangeSelectedRole, setOnchangeSelectedRole] = useState();
  const [singleEnterpriseClients, setSingleEnterpriseClients] = useState([]);
  // const [showSendInvitePopup, setShowSendInvitePopup] = useState(false);
  const [apiError, setApiError] = useState(false);

  const [filters, setFilter] = useState({
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });
  const [showInvite, setShowInvite] = useState(false);

  // const [selectedRole, setSelectedRole] = useState({
  //   value: 'Admin',
  //   key: 'admin',
  // });

  const roleOptions = [
    { value: 'ENTERPRISE_ADMIN', key: 'ENTERPRISE_ADMIN' },
    { value: 'ENTERPRISE_USER', key: 'ENTERPRISE_USER' },
  ];

  // const { data, loading, error, refetch } = useQuery(GetEnterpriseByID);

  //Assign mutaions to variable
  const [checkClientRole] =
    useMutation(UpdateClientUser, {
      onCompleted: (data) => {
        setApiError(false);
        setSingleEnterpriseClients(
          singleEnterpriseClients.map((item) =>
            item.id === data.updateEnterpriseClientRoleById.id
              ? { ...item, role: data.updateEnterpriseClientRoleById.role }
              : item,
          ),
        );

        fetchUserManagementDetails();
      },

      onError: ({ graphQLErrors }) => {
        setApiError(true);
        if (graphQLErrors[0].extensions.response) {
          if (
            graphQLErrors[0].extensions.response.statusText === 'Unauthorized'
          )
            // Check if any of the GraphQL errors have a 401 status code
            toast.error(
              toastResponse(
                'error',
                ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST,
              ),
            );
        } else {
          toast.error(toastResponse('error', graphQLErrors[0].message));
        }
      },
    });

  const fetchUserManagementDetails = useCallback(async () => {
    //Animated Loader true
    dispatch(setLoaderTrue());
    try {
      const { data } = await client.query({
        query: GetEnterpriseUsers,
        // variables: { clientId: authReducer.enterpriseID, getEmployeeStatsByClientIdClientId2: authReducer.enterpriseID},
      });

      if (data && data.getEnterpriseUsers && data.getEmployeeStats) {
        setUser(
          data?.getEnterpriseUsers.map((item) => ({
            ...item,
            lastSeen: item.lastSeen !== null ? item.lastSeen : 'NA',
            createdBy: item.createdBy !== null ? item.createdBy : 'NA',
          })),
        );

        // setUser(data?.getEnterpriseClientsByEnterpriseId)

        // debugger
        // const { statusData } = await client.query({
        //     query: GetEnterpriseClientStats
        // });

        setSignleEnterpriseClientStatus({totalUsers: data?.getEmployeeStats?.total})
        // setUser(data?.getEnterpriseClientsByEnterpriseId);
      }

      //Animated Loader false
      dispatch(setLoaderFalse());
    } catch (error) {
      // if (error.networkError.statusCode) {
      //   const errorDetails = globalError(error.networkError.statusCode);
      //   toast.error(toastResponse('error', errorDetails.message));

      //   // dispatch(isLogout());
      //   // navigate("/user/login");
        
      //   // setTimeout(() => {
      //   //   window.location.href = '/user/login';
      //   // }, 500);
      // }
      //Animated Loader false
      dispatch(setLoaderFalse());

      console.error('Error in fetching enterprise list', error);
    }
  },[client, dispatch]);

  useEffect(() => {
    fetchUserManagementDetails();
  }, [fetchUserManagementDetails]);

  const nameBody = (rowData) => {
    const fullName = (rowData.firstName ? rowData.firstName : '').concat(
      ' ',
      rowData.lastName ? rowData.lastName : '',
    );
    return (
      <>
        <div>{fullName}</div>
      </>
    );
  };

  const roleBody = (rowData) => {
    return (
      <>
        <div>
          <Dropdown
            placeholder={rowData.role}
            value={rowData.role}
            onChange={(e) => {
              rowData.role === e.value ? setConfirm(false) : setConfirm(true);
              setSelectedRow(rowData);
              setOnchangeSelectedRole(e.value);
            }}
            options={roleOptions}
            optionLabel="value"
            style={{ width: '100%' }}
          />
        </div>
      </>
    );
  };

  const handleRowSelect = async (rowData) => {
    let checkParentNodeName =
      rowData.originalEvent.target?.parentNode?.className;
    if (
      checkParentNodeName.includes('p-dropdown') ||
      checkParentNodeName === 'p-dropdown-item' ||
      checkParentNodeName === 'p-dropdown-trigger'
    ) {
      setShowEdit(false);
    } else {
      try {
        const { data } = await client.query({
          query: GetEnterpriseClientById,
          variables: { getEnterpriseClientByIdId: rowData.data.id },
        });

        setSelectedRow(data.getEnterpriseClientById);
        setShowEdit(true);
      } catch (error) {
        console.error('Error fetching user list', error);
      }
    }
  };

  const fnHandleRoleChange = async () => {
    try {
      setConfirm(false);

      if (selectedRow) {
        //Call mutaion with parameter
        checkClientRole({
          variables: {
            updateClientUserId: selectedRow.id,
            input: {role: onChangeSelectedRole},
          },
        });
      } else {
        setShowEdit(false);
      }
    } catch (error) {
      console.error('Error fetching user list', error);
    }
  };

  return (
    <>
      <div className="row pt-4 pb-4">
        <div className="col-md-8">
          <div className="totalEnterpriseBlock me-7">
            <div className="blockTitle fw-bolder">Total Users</div>
            <div className="blockNumber">
              {singleEnterpriseClientStatus
                ? singleEnterpriseClientStatus.totalUsers
                : 'NA'}
            </div>
          </div>
        </div>
        <div className="col-md-4 text-center">
          <div className="btn-large-block theme btn-primary-lg">
            <button
              className="btn text-white fw-bolder w-100 h-100 p-0"
              onClick={() => {
                setShowInvite(true);
              }}
            >
              Invite User
            </button>
          </div>
        </div>
      </div>

      <div className="row m-0 customTable border">
        <div className="col-md-12">
          <div className="row customTable mainheader">
            <div className="col-md-8 ps-2 pt-1">
              <div className="customTable title">
                <label>Enterprise User</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="search-field position-relative">
                <div className="customTable static-search-mg">
                  <img
                    src={allImages.search}
                    className="img-fluid"
                    style={{ height: '1.2rem' }}
                    alt="search_icon"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control customTable custom-input-field"
                  value={globalFilterValue}
                  onChange={(e) => {
                    setFilter((filters) => ({
                      ...filters,
                      global: {
                        ...filters['global'],
                        value: e?.target?.value.trim(),
                      },
                    }));
                    setGlobalFilterValue(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 p-0">
          <DataTable
            value={user}
            rowHover="true"
            removableSort
            className="customTable tableHeight"
            globalFilterFields={[
              'firstName',
              'lastName',
              'role',
              'status',
              'lastSeen',
              'invitedBy',
            ]}
            filters={filters}
            onRowClick={handleRowSelect}
            emptyMessage={
              (
                <h5 className="text-center h-100  pt-4 fw-bolder w-100">
                  There is no data to display at the moment.
                </h5>
              )
            }
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            scrollable
            scrollHeight="flex"
            resizableColumns="true"
          >
            <Column
              field="name"
              header="Name"
              className="px-8"
              sortable
              body={nameBody}
            />
            <Column
              field="role"
              header="Role"
              sortable
              body={roleBody}
            />
            <Column field="status" header="Status" sortable />
            <Column field="lastSeen" header="Last Seen" sortable />
            <Column field="createdBy" header="Invited By" sortable />
          </DataTable>
        </div>
      </div>
      {/* <InviteUser
                showInvite={showInvite}
                onInviteHide={() => setShowInvite(false)}
            ></InviteUser> */}
      <SendInvitation
        show={showInvite}
        onHide={() => setShowInvite(false)}
        entityName=""
        entityLogo=""
        entityID={authReducer.enterpriseID}
        type="employee"
      />

      <EditUserDetails
        showEdit={showEdit}
        onEditHide={() => setShowEdit(false)}
        selectedRow={selectedRow}
        type="employee"
        refetch={() =>
          (window.location.href =
            '/enterprise/enterprise-admin/user-management')
        }
      />

      <ConfirmationPopup
        showConfirm={showConfirm}
        onConfirmHide={() => setConfirm(false)}
        headerText="Employee Role Change Confirmation"
        modalBody={`Are you sure you want to change ${selectedRow.firstName + ' ' + selectedRow.lastName + "'s"} role from ${selectedRow.role} to ${onChangeSelectedRole}?`}
        otherBtnText={'Confirm'}
        onConfirmStatus={() => {
          fnHandleRoleChange();
        }}
        checkError={apiError}
      />
    </>
  );
};
